import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";

import {
  getLMSCourses,
  courseSelect,
  sessionSelect,
  eventSelect,
} from "../../Redux/Actions/coursesAction";
import CourseOfferingActivityModal from "./courseOfferingActivityModal";
import Loader from "./../../components/Loader";
import DropDown from "../../components/DropDown";
import CommonModal from "../../components/CommonModal";
import "../../config";
import "../../components/CommonModal/manage-roster-modal.css";

export const mapCourses = (courses = []) =>
  courses.map(({ courseId, courseNumber, courseTitle, courseDescription }) => ({
    label: `${courseNumber} - ${courseTitle}`,
    value: courseNumber,
    selectedCourse: {
      course_id: courseId,
      course_number: courseNumber,
      course_name: courseTitle,
      courseDescription,
    },
  }));

export const mapSessions = (offerings = []) =>
  offerings.map((o) => ({
    label: `${o.offeringNumber} - ${o.offeringTitle}`,
    value: o.offeringNumber,
    selectedSession: {
      offering_id: o.offeringId,
      offering_number: o.offeringNumber,
      offering_name: o.offeringTitle,
      offering_description: o.offeringDescription,
      offering_mincapacity: o.minCapacity,
      offering_maxcapacity: o.maxCapacity,
      offering_waitlist: o.waitListEnabled,
      offering_start_date: o.offeringStartDate,
      offering_end_date: o.offeringEndDate,
    },
  }));

export const mapEvents = (activities = []) =>
  activities.map((a) => ({
    label: `${a.activityNumber} - ${a.activityTitle} - ${moment(a.activityDate).format("MM/DD/YYYY")} - ${moment(a.activityStartTime, "HH:mm:ss").format("hh:mm A")} - ${moment(a.activityEndTime, "HH:mm:ss").format("hh:mm A")} - ${a.activityTimeZone} - ${a.primaryClassroom}`,
    value: a.activityNumber,
    selectedEvent: {
      activity_id: a.activityId,
      activity_number: a.activityNumber,
      activity_name: a.activityTitle,
      activity_date: a.activityDate,
      activity_time: `${a.activityStartTime} - ${a.activityEndTime} - ${a.activityTimeZone}`,
      activity_venue: a.primaryClassroom,
    },
  }));

function OraclelearnScheduledTraining() {
  const [isLoading, setIsLoading] = useState(true);

  const [coadata, setCoadata] = useState([]); // Contains courses, offerings and activities list received from API
  const [courses, setCourses] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [events, setEvents] = useState([]);

  const [course, setCourse] = useState(null);
  const [session, setSession] = useState(null);
  const [event, setEvent] = useState(null);

  const navigate = useNavigate();

  // this baseApiUrl needs to be a constant and set globally
  //let baseApiUrl = "http://rldoraclelearn.localhost:8080/v1";
  let baseApiUrl = global.config.baseApiUrl;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { course: currentCourse, session: currentSession } = useSelector((state) => state.courses);
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // Get Courses
  useEffect(() => {
    async function getOraclelearnCourses() {
      var failed = false;
      let cached = sessionStorage.getItem("courses_offerings_activities");
      let data;

      if (!cached) {
        const res = await axios.post(`${baseApiUrl}/courses?name=course_offering_activity`, {
          instructorNumber: currentUser.usernumber,
        });
        data = res;
        sessionStorage.setItem("courses_offerings_activities", JSON.stringify(res));
      } else {
        data = JSON.parse(cached);
      }

      setCoadata(data);
      dispatch(getLMSCourses(data, failed));

      setCourses([
        { label: "Select a ILT Course", value: "Dummy", selectedCourse: {} },
        ...mapCourses(data.data.courses),
      ]);
      setIsLoading(false);
      localStorage.removeItem("currentCourse");
      localStorage.removeItem("currentSession");
      localStorage.removeItem("currentEvent");

      setSessions([]);
      setEvents([]);
    }

    getOraclelearnCourses();
  }, []);

  // Get Sessions/Offerings when Course changes
  useEffect(() => {
    if (!course || !coadata?.data?.offerings || !currentCourse) {
      return;
    }

    const offerings = coadata.data.offerings.filter(
      (o) =>
        o.courseId === currentCourse.course_id && o.courseNumber === currentCourse.course_number,
    );

    setSessions([
      { label: "Select a Classroom Offering", value: "Dummy", selectedSession: {} },
      ...mapSessions(offerings),
    ]);
    setEvents([]);
  }, [course]);

  /** Get Events/Activities when Session/Offering changes */
  useEffect(() => {
    if (!session || !coadata?.data?.activities || !currentSession) {
      return;
    }

    const activities = coadata.data.activities.filter(
      (a) =>
        a.offeringId === currentSession.offering_id &&
        a.offeringNumber === currentSession.offering_number,
    );

    setEvents([
      { label: "Select a Classroom Activity", value: "Dummy", selectedEvent: {} },
      ...mapEvents(activities),
    ]);
  }, [session]);

  const handleCourseChange = (e) => {
    const selected = courses.find((course) => course.value === e.currentTarget.value);
    dispatch(courseSelect(selected.selectedCourse));
    setCourse(e.currentTarget.value);
    setSession(null);
    setEvent(null);
  };

  const handleSessionChange = (e) => {
    const selected = sessions.find((session) => session.value === e.currentTarget.value);
    dispatch(sessionSelect(selected.selectedSession));
    setSession(e.currentTarget.value);
    setEvent(null);
  };

  const handleEventChange = (e) => {
    const selected = events.find((event) => event.value === e.currentTarget.value);
    dispatch(eventSelect(selected.selectedEvent));
    setEvent(e.currentTarget.value);
  };

  const onCourseSessionEventFormSubmit = (e) => {
    e.preventDefault();
    handleClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // history.push('/manageRoster');
    navigate("/manageOfferingActivityRoster", { replace: true });
    // return <Navigate to="/manageRoster" replace={true}/>;
  };

  return (
    <>
      {isLoading ? (
        <div style={{ width: "80px", margin: "auto" }}>
          <Loader />
        </div>
      ) : (
        <div className="col-md-12">
          <DropDown
            label="Select Course:"
            disabled={isLoading}
            value={course}
            options={courses}
            onChange={handleCourseChange}
          />

          <DropDown
            label="Select Offering:"
            disabled={!course || !(sessions.length > 1)}
            value={session}
            options={sessions}
            onChange={handleSessionChange}
          />

          <DropDown
            label="Select Activity:"
            disabled={!session || !(events.length > 1)}
            value={event}
            options={events}
            onChange={handleEventChange}
          />
        </div>
      )}

      <br />

      <div className="d-flex align-items-center justify-content-center">
        <Button variant="primary" onClick={handleShow} disabled={!course || !session || !event}>
          Confirm
        </Button>
      </div>

      <CommonModal
        show={show}
        onHide={handleClose}
        title={<Modal.Title>Confirm Selection</Modal.Title>}
        footer={
          <>
            <Button variant="dark" onClick={handleClose}>
              Close
            </Button>
            <Button variant="success" onClick={handleSubmit}>
              Continue
            </Button>
          </>
        }
        modalProps={{
          size: "lg",
          centered: true,
          className: "manage-roster-modal",
        }}
      >
        <CourseOfferingActivityModal onSubmit={onCourseSessionEventFormSubmit} />
      </CommonModal>
    </>
  );
}

export default OraclelearnScheduledTraining;
